import React, { useState } from "react";
import { DeleteComponent } from "../components/Delete";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { setDeleteState } from "../Redux/DeleteReducer/action";

export const LectureDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = location;
  const comingFrom = location.state.from;
  const user = useSelector((state) => state.AuthReducer.user);

  const handleBack = () => {
    navigate(comingFrom);
  };

  const handleEdit = () => {
    navigate(`/editLecture/${id}`, { state: { data: state.data } });
  };

  const handleCopy = () => {
    navigate(`/copyLecture/${id}`, { state: { data: state.data } });
  };

  const handleDelete = () => {
    dispatch(setDeleteState(true));
  };

  return (
    <div className="font-sans antialiased min-h-screen bg-gray-100">
      <nav>
        <Navbar name={user.name} role={user.roles.name} />
      </nav>
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between">
          <h2 className="font-semibold text-xl text-start text-gray-800 leading-tight">
            Lectures
          </h2>
          <div className="flex gap-2">
            <button
              className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer "
              type="Button"
              onClick={handleBack}
            >
              Back
            </button>
            <button
              className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer"
              type="Button"
              onClick={handleEdit}
            >
              Edit
            </button>
            <button
              className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer"
              type="Button"
            >
              Discussion
            </button>
            <button
              className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer"
              type="Button"
              onClick={handleCopy}
            >
              copy
            </button>
            <button
              className="border rounded-md border-trensparent py-2 px-4 bg-red-800 hover:bg-red-700 focus:bg-red-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer "
              type="Button"
              onClick={handleDelete}
            >
              delete
            </button>
          </div>
        </div>
      </header>
      <main>
        <div className="py-12">
          <DeleteComponent id={id} from={comingFrom} />
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
            <div className="bg-white m-auto mt-10 sm:mt-0 border-0 rounded-md shadow-md">
              <div className="p-6 text-left">
                <div className="text-xl font-medium text-black">
                  <span>{state.data.title}</span>
                </div>
                <span className="block text-blue-600 font-semibold uppercase text-base">
                  {state.data.batch}
                </span>
                <span className="text-gray-600 font-semibold text-sm">
                  {state.data.createdBy}
                </span>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Title</div>
                  <span className="w-3/5">{state.data.title}</span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-white ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Category-Type</div>
                  <div className="w-3/5">
                    <span className="bg-yellow-100 border-0 rounded-md px-1 font-bold uppercase text-yellow-400 ">
                      {state.data.category}
                    </span>
                    <span className="m-2 bg-blue-100 border-0 rounded-md px-1 font-bold uppercase text-blue-500">
                      {state.data.type}
                    </span>
                  </div>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Schedule</div>
                  <span className="w-3/5 px-1 font-bold gb-gray-100">
                    {state.data.startTime}
                  </span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-white ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Concludes</div>
                  <span className="w-3/5">{state.data.concludeTime}</span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5 ">Tags</div>
                  <div className="w-3/5 ">
                    <span className="bg-blue-100 text-blue-600 text-sm font-bold uppercase border-0 rounded-md">
                      {state.data.tag}
                    </span>
                  </div>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-white ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">User</div>
                  <span className="w-3/5">{state.data.createdBy}</span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Optional</div>
                  <span className="w-3/5">
                    {state.data.optional === true ? "Yes" : "No"}
                  </span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-white ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Hide Video</div>
                  <span className="w-3/5">
                    {state.data.hideVideo === true ? "Yes" : "No"}
                  </span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Zoom Link</div>
                  <span className="w-3/5">{state.data.zoomLink}</span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-white ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Created By</div>
                  <span className="w-3/5">{state.data.createdBy}</span>
                </div>
              </div>
              <div className="px-6 py-4 text-left bg-gray-100 ">
                <div className="text-gray-600 flex font-semibold text-sm">
                  <div className="w-2/5">Updated By</div>
                  <span className="w-3/5">{state.data.updatedBy}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
